(function() {
  'use strict';

  // ── TOAST ──────────────────────────────────────
  function showToast(message) {
    var el = document.getElementById('nb-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function() { el.classList.remove('visible'); }, 3200);
  }

  // ── NAVIGATION ─────────────────────────────────
  function initNav() {
    var toggle = document.getElementById('nb-menu-toggle');
    var menu = document.getElementById('nb-nav-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nb-nav')) menu.classList.remove('is-open');
    });
    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { menu.classList.remove('is-open'); });
    });
  }

  // ── COUNTRY / MARKET SWITCHER ───────────────────
  // Selection is handled by Shopify's native `{% form 'localization' %}`
  // (see snippets/site-header.liquid): clicking a country sets the form's
  // hidden `country_code` input and submits the form. Shopify sets the
  // market/currency for the session server-side and reloads the page with
  // server-rendered prices in the correct active-market currency. This code
  // never computes or stores a currency itself — it only drives the form.
  function initCurrency() {
    var btn = document.getElementById('nb-currency-btn');
    var dropdown = document.getElementById('nb-currency-dropdown');
    var form = document.getElementById('nb-country-form');
    var input = document.getElementById('nb-country-code-input');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });

    document.addEventListener('click', function() {
      dropdown.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });

    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    dropdown.querySelectorAll('.nb-currency-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var code = opt.dataset.countryCode;
        if (!code || !form || !input) return;
        input.value = code;
        form.submit();
      });
    });
  }

  // ── QUANTITY SELECTOR ──────────────────────────
  var currentVariantId = null;

  function initQtySelector() {
    var options = document.querySelectorAll('.nb-qty-option');
    if (!options.length) return;
    selectOption(options[0]);
    options.forEach(function(opt) {
      opt.addEventListener('click', function() { selectOption(opt); });
      opt.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(opt); } });
    });
  }

  function selectOption(opt) {
    document.querySelectorAll('.nb-qty-option').forEach(function(o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
    });
    opt.classList.add('is-selected');
    opt.setAttribute('aria-checked', 'true');
    currentVariantId = opt.dataset.variantId || null;
  }

  // ── SHOPIFY AJAX CART ──────────────────────────
  function addToCart() {
    if (!currentVariantId) { showToast('Please select an option!'); return; }
    var btn = document.getElementById('nb-atc-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(currentVariantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) { showToast('Error: ' + (data.description || data.message || 'Unknown error')); }
      else { showToast('✓ Added to cart!'); refreshCart(); openCartDrawer(); }
    })
    .catch(function() { showToast('Something went wrong. Please try again.'); })
    .finally(function() { if (btn) { btn.disabled = false; btn.innerHTML = '🛒 Add to Cart'; } });
  }

  // ── CART DRAWER ────────────────────────────────
  function openCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {});
  }

  function renderCart(cart) {
    document.querySelectorAll('.nb-cart-badge').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var body = document.getElementById('nb-cart-body');
    var footer = document.getElementById('nb-cart-footer');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="nb-cart-empty"><div class="nb-cart-empty-icon">🛍️</div><p style="font-weight:600;margin-bottom:6px">Your cart is empty</p><p style="font-size:13px">Add products to start shopping</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<span style="font-size:28px">⌚</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="nb-cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var price = formatPrice(item.line_price, cart.currency);
      return '<div class="nb-cart-item">' +
        '<div class="nb-cart-item-img">' + img + '</div>' +
        '<div class="nb-cart-item-body">' +
          '<div class="nb-cart-item-name">' + escapeHtml(item.product_title) + '</div>' +
          variant +
          '<div class="nb-cart-item-variant">Qty: ' + item.quantity + '</div>' +
          '<div class="nb-cart-item-price">' + price + '</div>' +
        '</div>' +
        '<button class="nb-cart-item-remove" onclick="NB.removeCartItem(\'' + item.key + '\')" aria-label="Remove">✕</button>' +
      '</div>';
    }).join('');
    if (footer) {
      footer.style.display = 'block';
      var totalEl = document.getElementById('nb-cart-total-price');
      if (totalEl) totalEl.textContent = formatPrice(cart.total_price, cart.currency);
    }
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); showToast('Item removed'); })
    .catch(function() { showToast('Could not remove the item.'); });
  }

  // ── GALLERY ────────────────────────────────────
  function initGallery() {
    var thumbs = document.querySelectorAll('.nb-gallery-thumb');
    if (!thumbs.length) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt || '';
        if (!src) return;
        var main = document.getElementById('nb-main-img');
        if (main) { main.src = src; main.alt = alt; }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ── FAQ ────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.nb-faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.nb-faq-item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  // ── ORDER TRACKING ─────────────────────────────
  function trackOrder() {
    var input = document.getElementById('nb-track-input');
    var result = document.getElementById('nb-track-result');
    if (!input || !result) return;
    var val = input.value.trim();
    if (!val) { showToast('Please enter an order number'); return; }
    var steps = [
      { label: 'Order received', time: '3 days ago', done: true },
      { label: 'Packed at warehouse', time: '2 days ago', done: true },
      { label: 'Shipped with PostNord', time: 'Yesterday at 2:22 PM', done: true },
      { label: 'On its way to you', time: 'Expected today', done: false, current: true },
      { label: 'Delivered', time: 'Expected tomorrow', done: false }
    ];
    result.innerHTML = '<p style="font-weight:600;font-size:14px;margin-bottom:12px">Order: ' + escapeHtml(val) + '</p>' +
      steps.map(function(s) {
        var cls = 'nb-track-dot' + (s.done ? ' is-done' : '') + (s.current ? ' is-current' : '');
        return '<div class="nb-track-step"><div class="' + cls + '"></div><div class="nb-track-info"><strong>' + s.label + '</strong><span>' + s.time + '</span></div></div>';
      }).join('');
    result.classList.add('is-visible');
  }

  // ── REVIEW FORM ─────────────────────────────────
  function initReviewStars() {
    var stars = document.querySelectorAll('.nb-star-input');
    var rating = 0;
    stars.forEach(function(star) {
      star.addEventListener('click', function() {
        rating = parseInt(star.dataset.star);
        stars.forEach(function(s) {
          s.classList.toggle('is-active', parseInt(s.dataset.star) <= rating);
        });
      });
      star.addEventListener('mouseenter', function() {
        var hover = parseInt(star.dataset.star);
        stars.forEach(function(s) {
          s.style.color = parseInt(s.dataset.star) <= hover ? '#f59e0b' : '';
        });
      });
      star.addEventListener('mouseleave', function() {
        stars.forEach(function(s) {
          s.style.color = s.classList.contains('is-active') ? '#f59e0b' : '';
        });
      });
    });
  }

  function submitReview() {
    var name = document.getElementById('review-name');
    var text = document.getElementById('review-text');
    var activeStars = document.querySelectorAll('.nb-star-input.is-active').length;
    if (!name || !name.value.trim()) { showToast('Please enter your name'); return; }
    if (activeStars === 0) { showToast('Please select a rating'); return; }
    if (!text || !text.value.trim()) { showToast('Please write your review'); return; }
    showToast('✓ Thanks for your review! It will be reviewed and published soon.');
    document.getElementById('nb-review-form').classList.remove('is-visible');
    if (name) name.value = '';
    if (text) text.value = '';
    document.querySelectorAll('.nb-star-input').forEach(function(s) { s.classList.remove('is-active'); });
  }

  // ── UTILS ──────────────────────────────────────
  // Formats an amount in minor units (as returned by the Shopify Ajax Cart
  // API, e.g. /cart.js) using the cart's own active-market currency code.
  // No manual conversion or exchange rate is ever applied — the amount and
  // currency both come straight from Shopify for the buyer's current market.
  function formatPrice(cents, currencyCode) {
    var amount = cents / 100;
    if (!currencyCode) {
      // Shouldn't happen (cart.js always includes `currency`), but avoid
      // ever silently mislabeling an amount with the wrong currency.
      return amount.toLocaleString();
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount + ' ' + currencyCode;
    }
  }
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── PUBLIC API ──────────────────────────────────
  window.NB = {
    addToCart: addToCart,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    removeCartItem: removeCartItem,
    trackOrder: trackOrder,
    submitReview: submitReview,
    showToast: showToast
  };

  // ── INIT ────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initNav();
    initCurrency();
    initQtySelector();
    initGallery();
    initFaq();
    initReviewStars();
    refreshCart();

    var backdrop = document.getElementById('nb-cart-backdrop');
    if (backdrop) backdrop.addEventListener('click', closeCartDrawer);
  });

})();
